import { EmojiProps } from "./Emoji";

export const useEmojiDefaultValues = (props: EmojiProps.Emoji) => {
  const { size } = props;

  const defaultSize: EmojiProps.Props["size"] = 24;

  return { size: size || defaultSize };
};
